<template>
  <div class="">
    <div v-if="!this.data && this.pending" class="row">
      <loading></loading>
    </div>
    <div v-else-if="this.data && !this.pending" class="row">
      <div class="col-3">
        <listeEspace
          :mode-vue="modeVue"
          :hideGenerate="hideGenerate"
          style="overflow-y: auto;"
          :tableau-data="this.data"
        ></listeEspace>
      </div>
      <div class="col-9">
        <loading v-if="this.loading && !this.ficheData"></loading>
        <ficheEspaceContent
          style="height: calc(100vh - 100px); overflow-y: auto;"
          v-else-if="!this.loading && this.ficheData"
          :fiche="this.ficheData"
          :mode-vue="modeVue"
        ></ficheEspaceContent>
      </div>
    </div>
  </div>
</template>

<script>

import listeEspace from '../../components/ficheEspace/listeEspace'
import ficheEspaceContent from '../../components/ficheEspace/ficheEspaceContent'
import { mapActions, mapGetters } from 'vuex'
import loading from '../../components/loading'

export default {
  components: {
    listeEspace,
    ficheEspaceContent,
    loading
  },
  data () {
    return {
      data: null,
      ficheData: null,
      modeVue: false,
      hideGenerate: true
    }
  },
  methods: {
    ...mapActions(['setIsFromNotif', 'setIsLoadedComments', 'setEntityId', 'setTypeModule', 'getListOnglet', 'getTableauSurface', 'getAllDataTableauSurface', 'loadInviteFiche', 'setCurrentProject', 'getInviteFicheTableauData', 'setLoading', 'setPending', 'setCurrentFiche', 'setLastFiche']),
    ...mapGetters(['currentLigne', 'projectId', 'tableauSurfaceList', 'isLoadingTableauData', 'isFicheLoaded', 'getFiche', 'isLoadingFicheData', 'currentFicheData', 'lastFiche'])
  },
  computed: {
    ...mapGetters(['tableauData', 'currentFiche', 'currentProject', 'loading', 'ficheTableauData', 'pending', 'notifLink', 'isFromNotif'])
  },
  watch: {
    ficheTableauData: {
      handler (newValue) {
        console.log('newValue', newValue)
        this.data = [...newValue]
      },
      deep: true
    },
    async currentFiche (newValue, oldValue) {
      if (newValue != null) {
        try {
          this.setLoading(true)
          this.ficheData = null
          await this.loadInviteFiche({ficheId: newValue, ligne: this.currentLigne(), invitation: this.$route.params.idInvitation})
          this.ficheData = this.currentFicheData()
        } catch (e) {
        } finally {
          this.setLoading(false)
        }
      }
    },
    async notifLink (newValue) {
      if (newValue.entite !== this.currentFiche) {
        this.setPending(true)
        this.setIsLoadedComments(false)
        this.setEntityId(newValue.entite)
        await this.getInviteFicheTableauData({
          projet: newValue.projet.idt,
          invitation: this.$route.params.idInvitation
        })
        this.setCurrentFiche(newValue.entite)
        this.setPending(false)
      }
      this.setIsFromNotif(true)
    }
  },
  async created () {
    if (this.$route.params.tokenInvite) {
      this.modeVue = true
    }
    this.setTypeModule('fiche_espace')
    const idProject = this.$route.params.idProject
    if (this.currentProject == null || (idProject + '' !== this.currentProject + '')) {
      this.setCurrentProject(idProject)
    }

    this.setPending(true)
    await this.getInviteFicheTableauData({
      projet: this.currentProject,
      invitation: this.$route.params.idInvitation
    })

    this.setCurrentFiche(null)
    if (this.notifLink) {
      this.setCurrentFiche(this.notifLink.entite)
      this.setEntityId(this.notifLink.entite)
      this.setPending(false)
      return
    }
    if (this.lastFiche() != null) {
      this.setCurrentFiche(this.lastFiche())
      this.setLastFiche(null)
    }

    this.setPending(false)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pageFicheEspace/pageInviteFicheEspace.vue